export function isArticleNumber(value: string): boolean {
  return Boolean(value.match('^[\\d, ]*$'))
}
export function isDepotNumber(value: string): boolean {
  return Boolean(value.match('^[\\d, ]*$'))
}
